import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  content: {
    flexGrow: 1,
  },
}));

export default useStyles;
